import { useCallback } from 'react';

const useScrollIntoView = (scrollToTop) => useCallback((node) => {
    if (node !== null) {
        node.scrollIntoView(scrollToTop);
    }
}, [scrollToTop]);

export default useScrollIntoView;
